import styled from 'styled-components'

export const StyledMyPageLatestIndustryVolumesInsights = styled.div`
  .bottomTextLink {
    font-size: 24px;
  }
`
